import { FeatureCategory } from '../types';

export const familyPlusFeatures: FeatureCategory = {
  name: "FamilyPlus-Only Enhancements",
  icon: "Heart",
  features: [
    { 
      name: "Care Load Tracking", 
      description: "Track and measure your caregiving responsibilities to understand the time and effort you're investing in care.",
      starter: "—", max: "—", family: "—", familyPlus: "✔", careAddOn: "—"
    },
    { 
      name: "Self-Care Reminders", 
      description: "Personalized reminders to take care of your own wellness as a caregiver, preventing burnout.",
      starter: "—", max: "—", family: "—", familyPlus: "✔", careAddOn: "—"
    }
  ]
};
